import { Button } from 'blaze-ui/Button'
import { IntegrationInitializationContent } from './IntegrationInitializationContent'
import Styles from './IntegrationInitializationDrawer.module.scss'
import { ArrowUpRightSquareContained } from 'blaze-ui/icons'
import { IntegrationInitializationComponentProps } from './types'

interface Props extends Omit<IntegrationInitializationComponentProps, 'onClose'> {}

export const IntegrationInitializationDrawer = ({ primaryButtonText, onConfirm, ...props }: Props) => (
  <div className={Styles.container}>
    <IntegrationInitializationContent {...props} />
    <Button
      size="lg"
      onPress={onConfirm}
      endIcon={ArrowUpRightSquareContained}
      fullWidth
      aria-label={primaryButtonText}
    >
      {primaryButtonText}
    </Button>
  </div>
)
